// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.array-container {
    margin-top: 10px;
}

.array-item {
    border: 1px solid var(--bs-chinese-silver);
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    background-color: var(--bs-ghost-white);
}

.card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    margin: 10px;
}

.card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
    
.json-card {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    margin: 10px;
    padding: 10px;
    border-radius: 5px;
    background-color: var(--white);
}

.card:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

.card p {
    margin: 5px 0;
}

.small-font {
    font-size: 0.8rem; /* Adjust the font size as needed */
}`, "",{"version":3,"sources":["webpack://./src/assets/css/componentStyles/JsonCardView.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB,EAAE,mCAAmC;AAC1D","sourcesContent":[".array-container {\n    margin-top: 10px;\n}\n\n.array-item {\n    border: 1px solid var(--bs-chinese-silver);\n    border-radius: 5px;\n    padding: 10px;\n    margin-bottom: 10px;\n    background-color: var(--bs-ghost-white);\n}\n\n.card {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 20px;\n    margin: 10px;\n}\n\n.card-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n    \n.json-card {\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    transition: 0.3s;\n    margin: 10px;\n    padding: 10px;\n    border-radius: 5px;\n    background-color: var(--white);\n}\n\n.card:hover {\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.card p {\n    margin: 5px 0;\n}\n\n.small-font {\n    font-size: 0.8rem; /* Adjust the font size as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
